import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BackgroundSVG } from 'pages/_layouts/BackgroundLayout/BackgroundLayout';
import { Icon } from 'shared/components';
import requestsStatuses from 'modules/common/constants/requestsStatuses';

import theme from './CreateAppointmentSuccess.scss';

const propTypes = {
  serviceName: PropTypes.string.isRequired,
  requestStatus: PropTypes.string.isRequired,
};

const CreateAppointmentSuccess = ({ serviceName, requestStatus }) => (
  <div className={ theme.root }>
    <BackgroundSVG />
    <div className={ theme.container }>
      <div className={ theme.checkMark }>
        <div className={ theme.iconContainer }>
          <Icon className={ theme.icon } name="check" />
        </div>
      </div>
      <div className={ theme.title }>
        <FormattedMessage
          id="Patient.Appointment.AppointmentScheduled.Page.Header"
          defaultMessage="** Appointment scheduled successfully"
        />
      </div>
      <div className={ theme.details }>
        <If condition={ serviceName && requestStatus === requestsStatuses.success }>
          <FormattedMessage
            id="Patient.Appointment.AppointmentScheduled.Page.Body"
            defaultMessage="** An Appointment for { serviceName } was scheduled successfully"
            values={{ serviceName }}
          />
        </If>
      </div>
    </div>
  </div>
);

CreateAppointmentSuccess.propTypes = propTypes;

export default CreateAppointmentSuccess;
